<template>
  <cube-scroll
    ref="contentScroll"
    :data="data"
    :options="options"
    @pulling-down="onPullingDown"
    @pulling-up="onPullingUp"
  >
    <slot />
    <!-- <template
      slot="pulldown"
      slot-scope="props"
    >
      <div
        v-if="props.pullDownRefresh"
        class="cube-pulldown-wrapper"
        :style="props.pullDownStyle"
      >
        <div
          v-if="props.beforePullDown"
          class="before-trigger"
          :style="{paddingTop: props.bubbleY + 'px'}"
        >
          <span :class="{rotate: props.bubbleY > 0}">↓</span>
        </div>
        <div
          v-else
          class="after-trigger"
        >
          <div
            v-show="props.isPullingDown"
            class="loading"
          >
            <cube-loading />
          </div>
          <transition name="success">
            <div
              v-show="!props.isPullingDown"
              class="text-wrapper"
            >
              <span class="refresh-text">数据已更新</span>
            </div>
          </transition>
        </div>
      </div>
    </template> -->
  </cube-scroll>
</template>

<script>

export default {
  props: {
    page: {
      type: Number,
      default: 1
    },
    total: {
      type: Number,
      default: 0
    },
    limit: {
      type: Number,
      default: 10
    },
    data: {
      type: Array,
      default: () => []
    },
    moreText: {
      type: String,
      default: undefined
    }
  },
  data () {
    return {
      options: {
        pullDownRefresh: {
          threshold: 60,
          stop: 44,
          stopTime: 1000,
          txt: this.$t('message["379"]')
        },
        pullUpLoad: {
          txt: {
            more: this.moreText !== undefined ? this.moreText : this.$t('message["473"]'),
            noMore: this.$t('message["624"]')
          },
          // visible: false
          threshold: -20 // 在上拉到超过底部 20px 时，触发 pullingUp 事件
        }
      },
      secondStop: 26
    }
  },
  methods: {
    onPullingDown () {
      let page = 1
      setTimeout(() => {
        this.$router.push({
          query: {
            ...this.$route.query,
            page
          }
        })
        this.$emit('loadData', { page })
        this.$refs.contentScroll.scrollTo(0, this.secondStop, 300)
        // this.$refs.contentScroll.forceUpdate(true) // 初始化距离
      }, 1000)
    },
    onPullingUp () {
      setTimeout(() => {
        let page = this.page
        if (page < Math.ceil(this.total / this.limit)) {
          page++
          this.$router.push({
            query: {
              ...this.$route.query,
              page
            }
          })
          this.$emit('loadData', { page, isPull: true })
        } else {
          this.pullUpLoadNoMoreTxt = this.$t('message["628"]')
          this.pullUpLoad = false
          this.$refs.contentScroll.forceUpdate(true)
        }
      }, 1000)
    }
  }
}
</script>

<style lang="scss" scoped>
.content-scroll-list-wrap {
  height: 100%;
  transform: rotate(0deg); // fix 子元素超出边框圆角部分不隐藏的问题
  position: absolute;
  top: 0;
  bottom: 0;
  overflow: hidden;
}
.cube-pulldown {
  position: relative;
}
.cube-pulldown-wrapper {
  text-align: center;

  .before-trigger {
    height: auto;
    font-size: 24px;
    align-self: flex-end;

    span {
      display: inline-block;
      line-height: 1;
      transition: all 0.3s;
      color: #666;
      padding: 15px 0;

      &.rotate {
        transform: rotate(180deg);
      }
    }
  }

  .after-trigger {
    flex: 1;
    margin: 0;

    .text-wrapper {
      margin: 0 auto;
      margin-top: 14px;
      padding: 5px 0;
      color: #498ec2;
      background-color: #d6eaf8;
    }
    >>> .cube-loading-spinners {
      margin: 0 auto !important;
    }
  }
}

::v-deep .cube-pullup-wrapper {
  .before-trigger {
    span {
      color: $gray2;
      font-size: 14px;
    }
  }
}

.success-enter-active,
.success-leave-active {
  transition: width 0.5s;
}

.success-enter,
.success-leave-to {
  width: 70%;
}

.success-enter-to,
.success-leave {
  width: 100%;
}
</style>
